/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ScreenOrientation {
    Landscape = 'landscape',
    Portrait = 'portrait',
    ForcedPortrait = 'forcedPortrait'
}

export function ScreenOrientationFromJSON(json: any): ScreenOrientation {
    return ScreenOrientationFromJSONTyped(json, false);
}

export function ScreenOrientationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenOrientation {
    return json as ScreenOrientation;
}

export function ScreenOrientationToJSON(value?: ScreenOrientation | null): any {
    return value as any;
}

